import axios from "axios";
import React, { useEffect, useState } from "react";
import { getLocalTime } from "../../utils/dateTimeByTZ";
import { coopsData } from "../../utils/coopsData";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FolderIcon from "@mui/icons-material/Folder";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddDocument from "./AddDocument"; // Import AddDocument component
import { useNavigate } from "react-router-dom";

type Props = {};
interface FileItem {
  id: string;
  fileName: string;
  type: string;
  url?: string;
  date: Date;
}

const Documents = (props: Props) => {
  const BASE_URL = process.env.REACT_APP_API_KEY;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [disable, setDisable] = useState(false);
  const [openDialogId, setOpenDialogId] = useState<null | string>(null);
  const [loading, setLoading] = useState(false);
  const [openFolderDialog, setOpenFolderDialog] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [openAddDocDialog, setOpenAddDocDialog] = useState(false); // State for the Add Document dialog
  const [currentFolderId, setCurrentFolderId] = useState(" ");
  const [selectedFolder, setselectedFolder] = useState(" ");
  const [folderList, setFolderList] = useState([]);
  const [checkForFolderName, setcheckForFolderName] = useState(false);
  const [editFolderID, setEditFolderID] = useState(null);
  const [openFolderEditDialog, setOpenEditFolderDialog] = useState(false);
  const [editFileType, setEditFileType] = useState("");
  const [showCoopsModal, setShowCoopsModal] = useState(false);
  const [loggedInSysNum, setLoggedInSysNum] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [userSystemNum, setUserSystemNum] = useState("");
  const [sysNum, setSysNum] = useState(["15063"]);
  const [coopData, setCoopData] = useState({ systemList: [] });
  const [all, setAll] = useState(true);
  const [username, setUsername] = useState("");
  const [selectedCoopKeys, setSelectedCoopKeys] = useState<string[]>(
    coopData?.systemList?.map((coop: any) => coop?.systemNumber)
  );
  const [sysNumber, setsysNumber] = useState(localStorage.getItem("systemNumber"));
  const [folderSysNum, setFolderSysNum] = useState([]);
  const [folderAllSysNum, setAllFolderSysNum] = useState([]);

  const navigate = useNavigate();

  const showToast = (message: string, type: "success" | "error") => {
    toast[type](message, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
    });
  };

  const closeCoopsModal = () => {
    setShowCoopsModal(false);
  };

  const openCoopsModal = () => {
    setShowCoopsModal(true);
  };

  const handleSearchChange = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchEmpty = () => {
    setSearchTerm("");
  };

  const filteredCoopData = searchTerm
    ? coopData && coopData.systemList
      ? coopData.systemList
        .filter(
          (coop: any) =>
            coop.systemName
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            coop.systemNumber.toString().includes(searchTerm)
        )
        .sort(
          (a: any, b: any) =>
            +selectedCoopKeys.includes(b.systemNumber) -
            +selectedCoopKeys.includes(a.systemNumber)
        )
      : []
    : coopData && coopData.systemList
      ? coopData.systemList
        .slice()
        .sort(
          (a: any, b: any) =>
            +selectedCoopKeys.includes(b.systemNumber) -
            +selectedCoopKeys.includes(a.systemNumber)
        )
      : [];

  const handleCheckboxChange = (coopKey: string) => {
    // Toggle the selected state for the coop key
    setSelectedCoopKeys((prevSelected) =>
      prevSelected.includes(coopKey)
        ? prevSelected.filter((key) => key !== coopKey)
        : [...prevSelected, coopKey]
    );
  };
  const isAllSelected = selectedCoopKeys.length === coopData.systemList.length;

  useEffect(() => {
    const username = localStorage.getItem("userName");
    setUsername(username || "");
  }, []);

  useEffect(() => {
    const systemNumber = localStorage.getItem("systemNumber") || "";

    if (systemNumber === "15063") {
      const fetchCoops = async () => {
        const coopData = await coopsData();
        setCoopData(coopData);

        // Automatically select all coop keys when data is fetched
        const allCoopKeys = coopData.systemList.map(
          (coop: any) => coop.systemNumber
        );
        setSelectedCoopKeys(allCoopKeys);
      };
      fetchCoops();
    } else {
      setSysNum((prevSysNum) => {
        // Check if systemNumber already exists in sysNum
        if (!prevSysNum.includes(systemNumber)) {
          return [...prevSysNum, systemNumber];
        }
        return prevSysNum; // If it exists, return the previous state unchanged
      });
      setAll(false);
    }
    setLoggedInSysNum(systemNumber);
  }, []);

  const handleAllCheckboxChange = () => {
    if (selectedCoopKeys.length === coopData.systemList.length) {
      // When deselecting all, keep the userSystemNum selected
      const newUserSystemNumSelected = userSystemNum ? [userSystemNum] : [];
      setSelectedCoopKeys(newUserSystemNumSelected);
      setAll(false);
    } else {
      // When selecting all, include all coop keys plus the userSystemNum if not already included
      const allCoopKeys = coopData.systemList.map(
        (coop: any) => coop.systemNumber
      );
      if (userSystemNum && !allCoopKeys.includes(userSystemNum)) {
        allCoopKeys.push(userSystemNum);
      }
      setSelectedCoopKeys(allCoopKeys);
      setAll(true);
    }
  };

  // const handleSubmit = async () => {
  //   setDisable(true);
  //   const token = localStorage.getItem("authtoken") || "";
  //   const formData = new FormData();
  //   formData.append("username", username);
  //   formData.append("all", JSON.stringify(all));
  //   formData.append("folderId", JSON.stringify(folderId))
  //   let systemNumber: any = [];

  //   if (loggedInSysNum === "15063") {
  //     systemNumber = all
  //       ? JSON.stringify([])
  //       : JSON.stringify(selectedCoopKeys);
  //   } else {
  //     systemNumber = JSON.stringify(sysNum);
  //   }

  //   formData.append("systemNumber", systemNumber);

  //   files.forEach((file) => {
  //     if (file instanceof Blob) {
  //       formData.append("file", file, file.name);
  //     }
  //   });

  //   try {
  //     const config = {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };
  //     const response = await axios.post(
  //       `${BASE_URL}/document/upload`,
  //       formData,
  //       config
  //     );

  //     if (response.status === 201) {
  //       setDisable(false);
  //       window.location.pathname = "/documents";
  //     } else {
  //       console.error("Submission failed", response.statusText);
  //       setDisable(false);
  //     }
  //   } catch (error) {
  //     console.error("Error submitting form", error);
  //     setDisable(false);
  //   }
  // };

  const handleFolderClick = (folderId: any, createdBy: any) => {
    // Navigate to the folder's page
    navigate(`/folder/${folderId}?createdBy=${createdBy}`)
  };

  const handleEditDialog = (folder: any) => {
    if (folder.folderId) {
      setEditFolderID(folder.folderId);
      setEditFileType("Folder");
      setFolderName(folder.fileName);
    } else {
      setEditFolderID(folder.id);
      setEditFileType("File");
      setFolderName(folder.fileName.split(".")[0]);
    }

    setOpenEditFolderDialog(true);
    setcheckForFolderName(false);

    // navigate(`/folder/${folderId}`);
  };

  const handleOpenAddDocDialog = (folderId: any, systemNumber: any, all: any) => {
    setCurrentFolderId(folderId);
    setFolderSysNum(systemNumber);
    setAllFolderSysNum(all);
    setOpenAddDocDialog(true);
  };

  const handleCloseAddDocDialog = () => {
    setOpenAddDocDialog(false);
  };

  const handleAddDoc = async () => {
    // Logic for adding document goes here
    window.location.pathname = "/documents/add";
  };

  const handleInputChange = (event: any) => {
    if (!editFolderID) {
      let checkDocName = folderList.some(
        (folder: any) => folder.foldername.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );
      setcheckForFolderName(checkDocName);
      setFolderName(event.target.value);
    } else {
      let checkDocName = folderList.some(
        (folder: any) =>
          folder.folderId !== editFolderID &&
          folder.foldername.trim().toLowerCase() === event.target.value.trim().toLowerCase()
      );
      setcheckForFolderName(checkDocName);
      setFolderName(event.target.value);
    }
  };

  const handleChangeFolderName = async (
    event: React.ChangeEvent<HTMLSelectElement>,
    item: any
  ) => {
    const token = localStorage.getItem("authtoken") || "";

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/document/updateFolderId`,
        { id: item.id, folderId: event.target.value },
        config
      );
      if (response.data.success) {
        fetchDocuments();
        fetchFolderNames();
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenFolderDialog = () => {
    setOpenFolderDialog(true);
    setcheckForFolderName(false);
    setEditFolderID(null);
    setEditFileType(" ");
  };

  const handleCloseFolderDialog = () => {
    setOpenFolderDialog(false);
    setFolderName(""); // Reset the folder name
  };

  const handleCloseEditFolderDialog = () => {
    setOpenEditFolderDialog(false);
    setFolderName(""); // Reset the folder name
  };

  const [files, setFiles] = useState<
    { id: string; fileName: string; type: string; date: Date }[]
  >([]);
  // const [folders, setFolders] = useState<{ folderid: string; fileName: string; type: string; date: Date }[]>([]);

  const handleCreateFolder = async () => {
    if (!folderName.trim()) return;
    const SystemNumber = localStorage.getItem("systemNumber");
    const token = localStorage.getItem("authtoken") || "";

    let newFolder;
    if (SystemNumber == '15063') {
      newFolder = {
        foldername: folderName,
        date: new Date(),
        systemNumber: selectedCoopKeys.length === coopData.systemList.length ? [] : selectedCoopKeys,
        folderId: Math.random().toString(36).substr(2, 9),
        all: selectedCoopKeys.length === coopData.systemList.length ? true : false,
        createdBy: SystemNumber
      };
    } else {
      newFolder = {
        foldername: folderName,
        date: new Date(),
        systemNumber: [SystemNumber, "15063"],
        folderId: Math.random().toString(36).substr(2, 9),
        all: false,
        createdBy: SystemNumber
      };
    }
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await axios.post(
      `${BASE_URL}/document/insertDocumentFolder`,
      newFolder,
      config
    );
    setEditFolderID(null);
    setEditFileType(" ");

    // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
    // existingFolders.unshift(newFolder);
    // localStorage.setItem("folders", JSON.stringify(existingFolders));

    fetchDocuments();
    fetchFolderNames();
    showToast("Folder created successfully", "success");
    setOpenFolderDialog(false);
    setFolderName(""); // Clear folder name after success
  };

  const handleEditFolder = async () => {
    if (!folderName.trim()) return;
    const SystemNumber = localStorage.getItem("systemNumber");
    const token = localStorage.getItem("authtoken") || "";
    if (editFileType === "Folder") {
      const editFolder = {
        foldername: folderName,
        date: new Date(),
        systemNumber: SystemNumber,
        folderId: editFolderID,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.post(
        `${BASE_URL}/document/editDocumentFolder`,
        editFolder,
        config
      );
      setEditFolderID(null);
      setEditFileType(" ");

      // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
      // existingFolders.unshift(newFolder);
      // localStorage.setItem("folders", JSON.stringify(existingFolders));

      fetchDocuments();
      fetchFolderNames();
      showToast("Folder Renamed successfully", "success");
      setOpenEditFolderDialog(false);
      setFolderName(""); // Clear folder name after success
    } else {
      const editFile = {
        filename: folderName,
        id: editFolderID,
      };

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.post(
        `${BASE_URL}/document/editDocumentFile`,
        editFile,
        config
      );
      setEditFolderID(null);
      setEditFileType(" ");

      // const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
      // existingFolders.unshift(newFolder);
      // localStorage.setItem("folders", JSON.stringify(existingFolders));

      fetchDocuments();
      fetchFolderNames();
      showToast("File Renamed successfully", "success");
      setOpenEditFolderDialog(false);
      setFolderName(""); // Clear folder name after success
    }
  };

  const fetchDocuments = async () => {
    setLoading(true);
    setFiles([]);
    const SystemNumber = localStorage.getItem("systemNumber");
    const token = localStorage.getItem("authtoken") || "";

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/document/getDocumentsTest/${SystemNumber}?page=${page}`,
        config
      );
      const backendFiles = response.data.allDocuments;
      setTotalPages(response.data.totalPages);

      // const localFolders = JSON.parse(localStorage.getItem("folders") || "[]");
      const allFiles = [...backendFiles];
      setFiles(allFiles);
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchFolderNames = async () => {
    setLoading(true);
    const token = localStorage.getItem("authtoken") || "";
    const sytemNumber = localStorage.getItem("systemNumber") || "";

    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/document/getFolderNames/${sytemNumber}`,
        config
      );
      const backendFiles = response.data.folderName;
      // setTotalPages(response.data.totalPages);

      // const localFolders = JSON.parse(localStorage.getItem("folders") || "[]");
      // const allFiles = [...localFolders, ...backendFiles];
      setFolderList(backendFiles);
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
    fetchFolderNames();
  }, [page]);

  const handleNext = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handlePrevious = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handleOpenDialog = (id: string) => {
    setOpenDialogId(id);
  };

  const handleCloseDialog = () => {
    setOpenDialogId(null);
    setEditFolderID(null);
    setEditFileType(" ");
  };

  const handleDeleteDoc = async (item: any) => {
    const token = localStorage.getItem("authtoken") || "";
    setOpenDialogId(null);
    try {
      // if (item.type === "folder") {
      //   const existingFolders = JSON.parse(localStorage.getItem("folders") || "[]");
      //   const updatedFolders = existingFolders.filter((folder: { id: any; }) => folder.id !== item.id);
      //   localStorage.setItem("folders", JSON.stringify(updatedFolders));
      //   showToast("Folder deleted successfully", "success");
      //   fetchDocuments();
      // } else {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const deleteResponse = await axios.delete(
        `${BASE_URL}/document/delete/${item.id}?type=${item.type}`,
        config
      );

      if (deleteResponse.data.success) {
        showToast(deleteResponse.data.message, "success");
        fetchDocuments();
        fetchFolderNames();
      } else {
        showToast("Failed to delete document", "error");
      }
    } catch (error) {
      showToast("Error deleting item", "error");
    }
  };

  const documents = files.map((file: any) => ({
    id: file._id || file.id,
    fileName: file.originalFileName || file.fileName,
    type: file.mimetype || "folder",
    url: file.url,
    date: file.date,
    folderId: file.folderId,
    createdBy: file.createdBy,
    systemNumber: file.systemNumber,
    all: file.all
  }));

  const handleDownload = (url: string, fileName: string) => {
    setDisable(true);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    setDisable(false);
  };

  return (
    <div>
      <ToastContainer />
      <div className="card-list">
        <h2 style={{ fontSize: "28px", fontWeight: "bold" }}>Documents</h2>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
        >
          <button
            className="blue"
            onClick={handleOpenFolderDialog}
            style={{ maxWidth: "150px" }}
          >
            Add Folder
          </button>
          <button
            className="blue"
            style={{ maxWidth: "150px" }}
            onClick={handleAddDoc}
          >
            Add Document
          </button>
        </div>
      </div>

      <hr />

      {loading ? (
        <div style={{ textAlign: "center" }}>
          <CircularProgress sx={{ color: "#134fcf !important" }} />
        </div>
      ) : (
        <div>
          {documents.length === 0 ? (
            <div style={{ textAlign: "center" }}>
              <b>No Documents Uploaded</b>
            </div>
          ) : (
            <div className="list-container">
              {documents.map((item) => (
                <div
                  className="card"
                  key={item?.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                >
                  <div>
                    {item.type === "folder" ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <FolderIcon style={{ marginRight: "10px" }} />
                        <h4 style={{ fontWeight: "bold" }}>{item.fileName}</h4>
                      </div>
                    ) : (
                      <h4 style={{ fontWeight: "bold" }}>
                        {item.fileName.split('.').slice(0, -1).join('.')}
                      </h4>
                    )}
                    <p>{getLocalTime(item.date)}</p>
                    {item.type !== "folder" ? (
                      <select
                        id="dropdown"
                        value={selectedFolder}
                        onChange={(event) =>
                          handleChangeFolderName(event, item)
                        } // Pass event and item as arguments
                      >
                        <option value="">Select a Folder</option>
                        {folderList.map((item: any) => (
                          ((item.systemNumber.includes(sysNumber) && sysNumber!=='15063') || sysNumber =='15063') && (
                            <option key={item.folderId} value={item.folderId}>
                              {item.foldername}
                            </option>
                          )
                        ))}
                      </select>
                    ) : null}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {item.type !== "folder" && (
                      <>
                        <button
                          className="blue"
                          style={{ alignSelf: "center" }}
                          onClick={() =>
                            handleDownload(item.url, item.fileName)
                          }
                          disabled={disable}
                        >
                          Download
                        </button>
                        <br />
                      </>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      {item.type === "folder" && (
                        <>
                          {(sysNumber === "15063" || sysNumber === item.createdBy) && (
                            <button
                              className="blue"
                              onClick={() => handleOpenAddDocDialog(item.folderId, item.systemNumber, item.all)}
                              style={{ marginLeft: "10px" }}
                            >
                              Add Document
                            </button>
                          )}
                        </>

                      )}
                      {item.type === "folder" && (
                        <button
                          className="blue"
                          onClick={() => handleFolderClick(item.folderId, item.createdBy)}
                          style={{ marginLeft: "10px" }}
                        >
                          Open Folder
                        </button>
                      )}

                      {(sysNumber === "15063" || sysNumber === item.createdBy) && (
                        <>
                          <Button
                            variant="contained"
                            className="muiButton blue"
                            onClick={() => handleEditDialog(item)}
                            style={{ marginLeft: "10px" }}
                          >
                            <EditIcon />
                          </Button>
                          <Button
                            variant="contained"
                            className="muiButton"
                            onClick={() => handleOpenDialog(item.id)}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              marginLeft: "10px",
                            }}
                          >
                            <DeleteIcon />
                          </Button>
                          <Dialog open={openDialogId === item.id} onClose={handleCloseDialog}>
                            <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
                            <DialogContent>
                              <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete {item.fileName}?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleCloseDialog} sx={{ color: "#134fcf" }}>
                                Cancel
                              </Button>
                              <Button onClick={() => handleDeleteDoc(item)} sx={{ color: "#134fcf" }}>
                                Yes
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </>
                      )}


                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {totalPages > 1 ? (
        <div className="pagination">
          <Button
            onClick={handlePrevious}
            disabled={page === 1}
            sx={{ color: "#134fcf" }}
          >
            Prev
          </Button>
          <Button
            onClick={handleNext}
            disabled={page === totalPages}
            sx={{ color: "#134fcf" }}
          >
            Next
          </Button>
        </div>
      ) : null}

      <Dialog open={openFolderDialog} onClose={handleCloseFolderDialog}>
        <div>
          <div>
            {showCoopsModal && (
              <div className="modal">
                <div className="modal-content">
                  <div>
                    <span className="close" onClick={closeCoopsModal}>
                      &times;
                    </span>
                  </div>
                  <div style={{ padding: "10px", textAlign: "left" }}>
                    <input
                      type="text"
                      placeholder="Search by name or number..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      style={{ width: "50%", padding: "10px" }}
                    />
                    <button
                      className="blue coopListBtn"
                      onClick={handleSearchEmpty}
                      style={{ margin: "10px" }}
                    >
                      Clear
                    </button>
                  </div>
                  {selectedCoopKeys.length !== 0 ? (
                    <div className="selectedCoopNumList">
                      {selectedCoopKeys.map((coop, index) => (
                        <span className="selectedCoopNum" key={index}>
                          {coop}
                        </span>
                      ))}
                    </div>
                  ) :
                    <div className="selectedCoopNumList">
                      <span className="selectedCoopNum">
                        15063
                      </span>
                    </div>
                  }
                  <div
                    className="modal-body"
                    style={{ height: "570px", overflowY: "auto" }}
                  >
                    <ul
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        padding: 0,
                      }}
                    >
                      <li className="coopNumberList">
                        <label style={{ cursor: "pointer" }}>
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={handleAllCheckboxChange}
                            style={{ cursor: "pointer" }}
                          />
                          <span style={{ marginLeft: 5 }}>All</span>
                        </label>
                      </li>
                      {filteredCoopData.map((coop: any) => (
                        <li key={coop.systemNumber} className="coopNumberList">
                          <label style={{ cursor: "pointer" }}>
                            <input
                              type="checkbox"
                              checked={
                                selectedCoopKeys.includes(coop.systemNumber) ||
                                coop.systemNumber === userSystemNum || coop.systemNumber === "15063"
                              }
                              onChange={() =>
                                handleCheckboxChange(coop.systemNumber)
                              }
                              style={{ cursor: "pointer" }}
                              disabled={coop.systemNumber === userSystemNum || coop.systemNumber === "15063"}
                            />
                            <span style={{ marginLeft: 5 }}>
                              {`${coop.systemName}-(${coop.systemNumber})`}
                            </span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div
            className="card-list"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <DialogTitle style={{ margin: 0 }}>Create Folder</DialogTitle>
            {loggedInSysNum === "15063" && (
              <button
                className="blue"
                onClick={openCoopsModal}
                style={{
                  cursor: disable ? "not-allowed" : "pointer",
                }}
              >
                CoopList
              </button>
            )}
          </div>

          {/* ✅ Only show folder input and actions when CoopList modal is NOT open */}
          {!showCoopsModal && (
            <>
              <DialogContent>
                <TextField
                  label="Folder Name"
                  fullWidth
                  value={folderName}
                  onChange={handleInputChange}
                  autoFocus
                />
                {checkForFolderName && (
                  <p style={{ color: "red" }}>Folder Name Already Exists</p>
                )}
              </DialogContent>

              <DialogActions>
                <Button
                  onClick={handleCloseFolderDialog}
                  sx={{ color: "#134fcf" }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleCreateFolder}
                  sx={{ color: "#134fcf" }}
                  disabled={!folderName.trim() || checkForFolderName}
                >
                  Create Folder
                </Button>
              </DialogActions>
            </>
          )}
        </div>
      </Dialog>

      <Dialog open={openFolderEditDialog} onClose={handleCloseEditFolderDialog}>
        <DialogTitle>
          {editFileType === "Folder" ? (
            <span>Edit Folder Name</span>
          ) : (
            <span>Edit File Name</span>
          )}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Folder Name"
            fullWidth
            value={folderName}
            onChange={handleInputChange}
            autoFocus
          />
          {checkForFolderName ? (
            <p style={{ color: "red" }}>Folder Name Already Exists</p>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseEditFolderDialog}
            sx={{ color: "#134fcf" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleEditFolder}
            sx={{ color: "#134fcf" }}
            disabled={!folderName.trim() || checkForFolderName}
          >
            {editFileType === "Folder" ? (
              <span>Edit Folder</span>
            ) : (
              <span>Edit File</span>
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Document Dialog */}
      <Dialog
        open={openAddDocDialog}
        onClose={() => setOpenAddDocDialog(false)}
      >
        <DialogTitle>Add New Document</DialogTitle>
        <DialogContent>
          <AddDocument folderId={currentFolderId} folderSysNum={folderSysNum} folderAllSysNum={folderAllSysNum} />{" "}
          {/* Render the AddDocument component */}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenAddDocDialog(false)}
            sx={{ color: "#134fcf" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Documents;
